<div mat-dialog-content>
    <p><b>Do you want to confirm the cost of this Kaizen?</b></p>
</div>
<div mat-dialog-actions>
    <button mat-flat-button type="button" color="primary" [mat-dialog-close]="true">Yes</button>
    <button  mat-flat-button type="button" color="primary" [mat-dialog-close]="false">No</button>
</div>